import { brandPrimary, brandPrimaryHover } from '../../../web/styles/colors';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'block',
		margin: '20px 0',
	},
	copy: {
		cursor: 'pointer',
		paddingLeft: 8,
	},
	date: {
		color: brandPrimaryHover,
		fontSize: 14,
	},
	jobId: {
		alignItems: 'center',
		color: '#0d0F11',
		display: 'flex',
		fontSize: 14,
		marginLeft: 20,
	},
	jobType: {
		color: brandPrimary,
		fontSize: 16,
	},
	revertContainer: {
		alignItems: 'center',
		display: 'inline-flex',
		marginTop: 8,
	},
	status: {
		color: '#858585',
		fontSize: 12,
	},
});
